var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCornerBorders(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.5408 0H0V58.5408C0 59.5837 0.845471 60.4292 1.88841 60.4292C2.93135 60.4292 3.77682 59.5837 3.77682 58.5408V3.77682H58.5408C59.5837 3.77682 60.4292 2.93135 60.4292 1.88841C60.4292 0.845471 59.5837 0 58.5408 0ZM58.5408 220H0V161.459C0 160.416 0.845471 159.571 1.88841 159.571C2.93135 159.571 3.77682 160.416 3.77682 161.459V216.223H58.5408C59.5837 216.223 60.4292 217.069 60.4292 218.112C60.4292 219.155 59.5837 220 58.5408 220ZM220 0H161.459C160.416 0 159.571 0.845471 159.571 1.88841C159.571 2.93135 160.416 3.77682 161.459 3.77682H216.223V58.5408C216.223 59.5837 217.069 60.4292 218.112 60.4292C219.155 60.4292 220 59.5837 220 58.5408V0ZM161.459 220H220V161.459C220 160.416 219.155 159.571 218.112 159.571C217.069 159.571 216.223 160.416 216.223 161.459V216.223H161.459C160.416 216.223 159.571 217.069 159.571 218.112C159.571 219.155 160.416 220 161.459 220Z",
    fill: "#4CAF50"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerBorders);
export default __webpack_public_path__ + "static/media/cornerBorders.312abd058fd12ad58c4bfa066f07be1e.svg";
export { ForwardRef as ReactComponent };